<template>
    <div class="layout">
        <Header
            :style="{height:'80px',background: '#fff',color:'#3569fd',fontSize:'20px',fontWeight:700,lineHeight:'80px',paddingLeft:'40px'}">
            <div class="login_name" @mouseenter="showdiv=true" @mouseleave="showdiv=false">
                <span>{{realname}}</span>
                <img src="@/assets/img/tranup.png" alt="" v-show="showdiv">
                <img src="@/assets/img/trandown.png" alt="" v-show="!showdiv">
                <transition name="fade">
                    <div class="selectname" v-show='showdiv'>
                        <!-- <p @click="$router.push('/userInfor')" v-if="usertype=='person'">个人资料</p> -->
                        <!-- <p @click="$router.push({path:'/companyInfor',query:{id:companyId}})" v-else>企业资料</p> -->
                        <p @click="$router.push('/repassword')">修改密码</p>
                        <p @click="ResetModel=true">退出登录</p>
                    </div>
                </transition>
            </div>
            <div class="msg" @click="showmsgdiv=true" style="margin-right:10px;" @mouseleave="showmsgdiv=false">
                <span style="height:80px;display:inline-block;width:90px;text-align:center;">
                    <img src="@/assets/img/icon_msg.png" alt="" style="height:15px;width:13px;"
                        v-if="noticeList.length==0">
                    <img src="@/assets/img/icon_hasmsg.png" alt="" style="height:15px;width:16px;" v-else>
                </span>
                <transition name="fade">
                    <div class="msgbox" v-show='showmsgdiv'>
                        <ul>
                            <li v-for="(item,index) in noticeList">
                                <div @click="topage(item.noteType,item.id,item.noteTitle)">
                                    <span style="color: #3569fd;margin-right:18px;">[{{item.noteType}}]</span>
                                    <span>{{item.pubTime}}</span>
                                </div>
                                <div
                                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width:216px;display:block;">
                                    <span>{{item.noteTitle}}-{{item.communityName}}</span>
                                </div>
                            </li>
                        </ul>
                        <span style="color: #3569fd;cursor:pointer;" @click="$router.push('/systemMsg')">查看更多</span>
                    </div>
                </transition>
            </div>
            <span>TAL射箭连锁管理系统</span>
        </Header>
        <Sider
            :style="{position: 'fixed', height: '90vh', left: 0, overflow: 'auto',background:'#fff',minWidth: '269px',maxWidth: '269px',top:'83px'}">
            <Menu theme="light" width="auto" on-collapse="slider" @on-select="routeTo" :active-name="setActive">
                <div v-for="(item,index) in menu">
                    <!-- <Submenu :name="item.children?(index+1):item.path"  v-if='item.children && item.children'> -->
                    <Submenu :name="'/'+item.path" v-if='item.hasChildrenShow==1'>
                        <template slot="title">
                            <!-- <Icon type="ios-navigate"></Icon> -->
                            {{item.meta.title}}
                            <!-- <router-link :to="item.children?'':item.path"></router-link> -->
                        </template>
                        <!-- <MenuItem :name="(index+1)+'-'+(i+1)" v-for="(child,i) in item.children"> -->
                        <MenuItem :name="'/'+child.path" v-for="(child,i) in item.children" v-if="child.hidden!==1">
                        <!-- <router-link :to="child.path">{{child.meta.title}}</router-link> -->
                        {{child.meta.title}}
                        </MenuItem>
                    </Submenu>
                    <!-- 为了前端脱离后端删除斜杠 -->
                    <MenuItem :name="'/'+item.path" v-else :style="{paddingLeft:'40px'}">
                    <!-- <MenuItem :name="item.path" v-else :style="{paddingLeft:'40px'}"> -->
                    <!-- <Icon type="ios-navigate"></Icon> -->
                    <span>{{item.meta.title}}</span>

                    </MenuItem>

                </div>

            </Menu>
        </Sider>
        <Layout :style="{marginLeft: '269px',height:'calc(100vh - 93px)',background:'#eff0f8',marginTop:'6px'}">

            <Content :style="{padding: '0 16px 0'}">
                <Breadcrumb :style="{margin: '16px 0'}">
                    <!-- <BreadcrumbItem>{{$router.mate.title}}</BreadcrumbItem> -->
<!--                    <BreadcrumbItem><span style="font-weight: normal;">{{laytitle}}</span></BreadcrumbItem>-->
                </Breadcrumb>
                <!-- <Card style="height:100%;"> -->
                <div class="ivew-router-box">
                   <router-view/>
                </div>
                <!-- </Card> -->
            </Content>
        </Layout>
        <Modal v-model="ResetModel" title="提示!" @on-ok="Resetok" @on-cancel="ResetModel=false;">
            <p>是否要退出当前系统?</p>
        </Modal>
    </div>

    <!-- <ul>
      <li v-for="item in menu">
        <router-link :to="item.path">{{item.meta.title}}</router-link>
      </li>
    </ul> -->
</template>

<script>
import { getmenu } from "@/api/axios";
import { admin } from "@/api/admin";
import { hasbtn } from "@/utils/commondata";
export default {
    name: "HelloWorld",
    props: {
        msg: String,
    },
    data() {
        return {

            ResetModel: false,
            menu: [],
            laytitle: "",
            realname: sessionStorage.realName,
            showdiv: false,
            showmsgdiv: false,
            noticeList: [],
            usertype: "person",
            companyId: sessionStorage.companyId,
        };
    },
    mounted() {
        if (
            sessionStorage.roleCode == "estateAgencyCo" ||
            sessionStorage.roleCode == "apartmentCo" ||
            sessionStorage.roleCode == "thirdServiceCo"
        ) {
            this.usertype = "company";
        } else {
            this.usertype = "person";
        }
        //this.getnotice();
        let menu = JSON.parse(sessionStorage.menu);
        this.menu = menu;
        if (this.$router.history.current.query.titleadd) {
            this.laytitle =
                this.$router.history.current.meta.title +
                this.$router.history.current.query.titleadd;
        } else {
            this.laytitle = this.$router.history.current.meta.title;
        }
    },
    computed: {
        setActive() {
            if (this.$route.path.split("/").length > 2) {
                return "/" + this.$route.path.split("/")[1];
            } else {
                return this.$route.path;
            }
        },
    },

    methods: {
        // getnotice() {
        //     admin.getnoticeModel().then((res) => {
        //         if (res.data.success == true) {
        //             for (var i = 0; i < res.data.result.records.length; i++) {
        //                 res.data.result.records[i].pubTime =
        //                     res.data.result.records[i].pubTime
        //                         .split(" ")[0]
        //                         .split("-")
        //                         .join(".") +
        //                     " " +
        //                     res.data.result.records[i].pubTime.split(" ")[1];
        //             }
        //             this.noticeList = res.data.result.records;
        //         }
        //     });
        // },
        routeTo(e) {
            this.$router.push(e);
        },
        Resetok() {
            if (sessionStorage.token) {
                admin.loginout().then((res) => {
                    if (res.data.success == true) {
                      this.$router.go(0)
                    }
                });
                sessionStorage.clear();
                this.$router.replace("/");
            } else {
                sessionStorage.clear();
                this.$router.replace("/");
            }
        },
        topage(type, id, title) {
            // let path='';
            // if(type=='实勘任务'){//悦居经纪人
            //   path='/MyHome/Index';  //我的实勘任务
            // }else if(type=='房源发布'){//悦居经纪人
            //   path="/Mh/Index";  //我的房源
            // }else if(type=='交易流程'){//悦居经纪人
            //   path='/easy/list'; //我的交易
            // }else if(type=='数据审核' && sessionStorage.roleCode=='yuejuStoreManager' ){//悦居店长
            //   path='/long/Index'; //房源发布审核
            // // }else if(type=='数据审核' && sessionStorage.roleCode=='yuejuStoreManager' ){//悦居店长
            // //   path='/Audit'; //实勘任务退回审核
            // }else if((type=='数据审核' && sessionStorage.roleCode=='dataChecker' && title=='房源签约审核')){//数据审核员
            //   path='/Signin/Index'; //房源发布审核
            // }else if(type=='数据审核'  && sessionStorage.roleCode=='dataChecker' && title=='实勘任务退回审核'){
            //   path='/Audit';//实勘退回
            // }
            // if(hasbtn(this.$router.options.routes[1].children,path)){
            //   admin.changenoticeStatue(id).then(res=>{
            //   })
            //   this.$router.push(path);
            // }else{
            // }
        },
    },
    watch: {
        $route(to) {
            //this.getnotice();
            if (to.query.titleadd) {
                this.laytitle = to.meta.title + to.query.titleadd;
            } else {
                this.laytitle = to.meta.title;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.ivu-menu-item {
    text-align: left;
}
.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
    text-align: left;
    padding: 24px 24px;
}
.msg,
.login_name {
    float: right;
    height: 80px;
    position: relative;
}
.msg span,
.login_name span {
    vertical-align: middle;
    font-size: 14px;
    font-weight: 500;
    color: #2f2e42;
}
.msg img,
.login_name img {
    margin-left: 10px;
    vertical-align: middle;
    width: 7px;
    height: 4px;
}
.selectname {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100px;
    background: #fff;
    box-shadow: 3px 5px 5px #888888;
    z-index: 20;
}
.selectname p {
    line-height: 30px;
    padding: 0;
    margin: 0;
    text-align: center;
    color: #2f2e42;
    cursor: pointer;
}
.selectname p:hover {
    color: #3569fd;
}
.msgbox {
    width: 276px;
    max-height: 360px;
    box-sizing: border-box;
    padding: 24px 30px 14px;
    background: #fff;
    position: absolute;
    top: 80px;
    left: -130px;
    z-index: 20;
    box-shadow: 3px 5px 5px #888888;

    line-height: 30px;
}
.msgbox > ul {
    border-bottom: 1px solid #ebebeb;
    line-height: auto;
    padding: 0;
}
.msgbox span {
    color: #696969;
    line-height: 10px;
}
.ivew-router-box {
    height: calc(100vh - 150px);
    overflow: auto;
    padding-left: -16px;
    padding-right: -16px;
    background: #fff;
    min-width: auto;
    box-shadow: 0px 0px 21px 0px rgba(191, 199, 221, 0.26);
    border-radius: 4px;
}
</style>
